import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { ApplicationSettings } from "lib-config";
import { Observable } from "rxjs";
import { ReturnTypesForJurisdiction } from "../models/return-type.model";

@Injectable({
    providedIn: "root"
})
export class ReturnTypesService {

    constructor(private http: HttpClient, private settings: ApplicationSettings) {
        
    }
    
    getAllReturnTypes(): Observable<string[]> { 
        return this.http.get<string[]>('assets/dummy-json/credentials/return-types.json');
    }

    getReturnAndCredentialTypes(jurisdiction: string) {
        return this.http.get<ReturnTypesForJurisdiction>(this.settings.backendUrlCKT + `/api/CktReportType/ReportTypeByJurisdiction/${jurisdiction}`)
    }
}